// Gedeelde navigatie-helper: klik op een markt-glyph gaat naar de Markten-pagina
// en scrollt daar naar de kaart van die markt. Los getrokken uit MarketIcon.js
// zodat lib.js hem ook kan gebruiken zonder een importcirkel (MarketIcon.js
// leest HV2 uit lib.js, dus lib.js mag MarketIcon.js niet terug importeren).
import { appTabHref } from '@/lib/app-navigation.mjs';

// stopPropagation zodat een omliggende rij-klik (proceskaart) niet mee vuurt.
// Zet de sessionStorage-hint, ZET het hash (idempotent als het al #markten is)
// en vuurt daarna altijd het 'pb-markten-goto' event: MarketsPageView leest de
// hint bij mount via het hash, maar als de gebruiker al op Markten staat vuurt
// een ongewijzigd hash geen hashchange, dus luistert die pagina ook naar dit
// event om hetzelfde scroll/flash-gedrag alsnog te triggeren.
export function gotoMarkten(market, e) {
  if (e) e.stopPropagation();
  if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1)) {
    window.open(appTabHref('markten'), '_blank', 'noopener,noreferrer');
    return;
  }
  if (e) e.preventDefault();
  try { sessionStorage.setItem('pb-markten-goto', market); } catch { /* private mode */ }
  window.location.hash = 'markten';
  window.dispatchEvent(new Event('pb-markten-goto'));
}
